namespace Matrix.Workflow {
    export interface TaskInstanceDocumentRow {
        TaskInstanceDocumentId?: number;
        TaskInstanceId?: number;
        DocumentId?: string;
        DocumentDescription?: string;
        DocumentGroup?: string;
        RowId?: number;
        Version?: number;
        CreatedBy?: string;
        CreatedWhen?: string;
        UpdatedBy?: string;
        UpdatedWhen?: string;
        TaskInstanceWorkflowInstanceId?: number;
        TaskInstanceTaskId?: number;
        TaskInstanceStatusCode?: string;
        TaskInstanceRowId?: number;
        DocumentName?: string;
        DocumentType?: string;
        DocumentContent?: number[];
        DocumentVersion?: number;
        DocumentRowId?: number;
    }

    export namespace TaskInstanceDocumentRow {
        export const idProperty = 'TaskInstanceDocumentId';
        export const nameProperty = 'DocumentId';
        export const localTextPrefix = 'Workflow.TaskInstanceDocument';
        export const deletePermission = 'DataAdmin:TaskInstance';
        export const insertPermission = 'DataAdmin:TaskInstance';
        export const readPermission = 'Read:TaskInstance';
        export const updatePermission = 'DataAdmin:TaskInstance';

        export declare const enum Fields {
            TaskInstanceDocumentId = "TaskInstanceDocumentId",
            TaskInstanceId = "TaskInstanceId",
            DocumentId = "DocumentId",
            DocumentDescription = "DocumentDescription",
            DocumentGroup = "DocumentGroup",
            RowId = "RowId",
            Version = "Version",
            CreatedBy = "CreatedBy",
            CreatedWhen = "CreatedWhen",
            UpdatedBy = "UpdatedBy",
            UpdatedWhen = "UpdatedWhen",
            TaskInstanceWorkflowInstanceId = "TaskInstanceWorkflowInstanceId",
            TaskInstanceTaskId = "TaskInstanceTaskId",
            TaskInstanceStatusCode = "TaskInstanceStatusCode",
            TaskInstanceRowId = "TaskInstanceRowId",
            DocumentName = "DocumentName",
            DocumentType = "DocumentType",
            DocumentContent = "DocumentContent",
            DocumentVersion = "DocumentVersion",
            DocumentRowId = "DocumentRowId"
        }
    }
}
